<template>
    <v-app>
        <div class="boxed">
            <v-container>
                <span v-for="foot in feet" :key="foot['id']">
                    <input type="radio" v-model="chosenFeet" :id="foot.type" :value="foot.type">
                    <label :for="foot.type"><img :src="getFootImage(foot.type)" width="80px" class="image" >{{ foot.name }}</label>
                </span>
            </v-container>
            <div>
                <span v-for="alignment in alignments" :key="alignment['id']">
                    <input type="radio" v-model="chosenAlignment" :id="alignment.type" :value="alignment.type">
                    <label :for="alignment.type"><img :src="getAlignmentImage(alignment.type)" width="80px" class="image2">{{ alignment.name }}</label>
                </span>
            </div>
            <div>
                <span v-for="shoe in shoes" :key="shoe['id']">
                    <input type="radio" v-model="chosenShoes" :id="shoe.type" :value="shoe.type">
                    <label :for="shoe.type"><img :src="getShoesImage(shoe.type)" width="80px" class="image"/>{{ shoe.name }}</label>
                </span>
            </div>
        </div>
    </v-app>
</template>
<script>
import db from '@/components/firebase.init';
export default {
    data(){
        return{
            chosenFeet: '',
            chosenAlignment: '',
            chosenShoes:'',
            feet:[
                {
                    type: 'high',
                    name: 'High Arch'
                },
                {
                    type: 'normal',
                    name: 'Normal'
                },
                {
                    type: 'flat',
                    name: 'Flat'
                },
            ],
            alignments:[
                {
                    type: 'supination',
                    name: 'Supination'
                },
                {
                    type: 'neutral',
                    name: 'Neutral'
                },
                {
                    type: 'pronation',
                    name: 'Pronation'
                }
            ],
            shoes:[
                {
                    type:'cushioning',
                    name:'Cushioning'
                },
                {
                    type:'stability',
                    name:'Stability'
                },
                {
                    type:'motion',
                    name:'Motion'
                },
            ]
        }
    },
    methods:{
        getFootImage(foot){
            return require('@/assets/form2/'+foot+'.png');
        },
        getAlignmentImage(alignment){
            return require('@/assets/form2/'+alignment+'.png');
        },
        getShoesImage(shoes){
            return require('@/assets/form2/'+shoes+'.png');
        },
        submit(id){
            db.collection('forms').doc(id).update(
                {
                    feet: this.chosenFeet,
                    alignment: this.chosenAlignment,
                    shoes: this.chosenShoes
                }
            )
        }
    }
}
</script>
<style scoped>
.boxed {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 425px;
    height: 450px;
    margin: -225px 0 0 -212.5px;
    background-color : white;
    text-align: center;
    color: rgba(0,0,0,0.6);
    font-weight: 600;
    border-radius: 5px;
    padding-bottom: 0px;
}
.boxed label {    
    display: inline-block;
    width: 100px;
    height: 100px;
    padding: 10px;
    border: solid 2px #ccc;
    border-radius: 10px;
    transition: all 0.3s;
    text-align: center;
    margin-top: 17px;    
    background-color: rgb(75, 75, 75);
    cursor: pointer;
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
  }
  
  img{
      filter: opacity(40%);
  }
  .image2{
    filter: invert(100%);
}
  .boxed input[type="radio"] {
    display: none;
  }
  
  .boxed input[type="radio"]:checked + label{
    /* border: solid 2px #036e15; */
    background-color: #036e15; 
    color: rgb(0, 0, 0);  
  }
  .boxed input[type="radio"]:checked + label .image{
     filter: invert(100%);
  }
  .boxed input[type="radio"]:checked + label .image2{
    filter: invert(0%);
}

</style>


